var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-modal',{attrs:{"id":"modal-VirtualTourView","title":"View 360 degree","ok-only":"","ok-variant":"secondary","ok-title":"Close","size":"xl"}},[_c('div',[_c('iframe',{attrs:{"width":"100%","height":"500","src":this.viewSource,"frameborder":"0","allowfullscreen":"","allow":"xr-spatial-tracking"}})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }